import SupplierAckPage from "./components/acuse/SupplierAckPage";
import AcusesControlView from "./views/acuses/AcusesControlView";
import React from "react";

import InsumosProduccionView from './views/insumos/InsumosProduccionView.jsx';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FoliosCommandCenterView from "./views/folios/FoliosCommandCenterView";

import MenuLayout from "./layout/Menu.jsx";

import Home from "./views/Home.jsx";

import ProyectosDashboardView from "./views/proyectos/ProyectosDashboardView.jsx";

import ProyectosCommandCenterView from "./views/proyectos/ProyectosCommandCenterView.jsx";

import CotizacionesV2 from "./features/cotizaciones-v2";

import InventarioView from "./views/InventarioView";

import InventarioForm from "./components/InventarioForm";

import ContratosView from "./views/ContratosView";

import ContratoForm from "./components/ContratoForm";

import EmpleadosView from "./views/EmpleadosView.jsx";

import CredencialesView from "./views/CredencialesView.jsx";

import CredencialForm from "./components/CredencialForm.jsx";

import IncidenciasCrear from "./views/incidencias/IncidenciasCrear";

import IncidenciasListado from "./views/incidencias/IncidenciasListado";

import EvidenciasListado from "./views/incidencias/EvidenciasListado";

import IncidenciaDetalle from "./views/incidencias/IncidenciaDetalle";

import ReemplazosView from "./views/ReemplazosView.jsx";

import Configuracion from "./views/Configuracion";

import AccessControlView from "./views/configuracion/AccessControlView.jsx";

import ReportesComparativo from "./views/reportes/ReportesComparativo.jsx";

import VariacionEjecutiva from "./views/VariacionEjecutiva.jsx";

import VariacionMunicipiosMensual from "./views/VariacionMunicipiosMensual.jsx";

import AuthGate from "./auth/AuthGate";
import SessionGuardian from "./auth/SessionGuardian";
import RbacProvider from "./auth/RbacProvider";

import LoaderGate from "./utils/LoaderGate";

import Callback from "./pages/Callback.jsx";

import Logout from "./auth/Logout";

import { canViewModule } from "./auth/permissions";

import CredencialesTest from "./components/CredencialesTest.jsx";

import UploadDocumentos from "./components/UploadDocumentos.jsx";

import ArchivoDocumentosView from "./views/documentos/ArchivoDocumentosView.jsx";

import BuscarDocumentos from "./views/documentos/BuscarDocumentos.jsx";

import EmpleadoForm from "./components/EmpleadoForm.jsx";


import RemisionesEnvioView from "./views/insumos/RemisionesEnvioView";
import AccessAdminView from "./views/configuracion/AccessAdminView";
function AccessDenied() {
  return (
    <div
      style={{
        minHeight: "70vh",
        display: "grid",
        placeItems: "center",
        padding: 30,
      }}
    >
      <div
        style={{
          maxWidth: 520,
          width: "100%",
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: 18,
          padding: 26,
          boxShadow: "0 12px 30px rgba(15,23,42,.08)",
        }}
      >
        <div
          style={{
            fontSize: 12,
            fontWeight: 900,
            letterSpacing: ".12em",
            textTransform: "uppercase",
            color: "#64748b",
            marginBottom: 8,
          }}
        >
          Acceso restringido
        </div>

        <h1
          style={{
            margin: 0,
            fontSize: 24,
            fontWeight: 950,
            color: "#111827",
          }}
        >
          No tienes permisos para ver este mÃ³dulo
        </h1>

        <p
          style={{
            marginTop: 10,
            color: "#64748b",
            fontWeight: 650,
            lineHeight: 1.5,
          }}
        >
          Tu usuario no tiene privilegios suficientes para acceder a esta secciÃ³n.
          Si acabas de cambiar de rol, cierra sesiÃ³n e inicia sesiÃ³n nuevamente.
        </p>
      </div>
    </div>
  );
}

function RequireModule({ module, children }) {
  if (canViewModule(module)) return children;
  return <AccessDenied />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/proveedor/acuse" element={<SupplierAckPage />} />
        {/* ================= PUBLICAS ================= */}
        <Route path="/callback" element={<Callback />} />
        <Route path="/logout" element={<Logout />} />

        {/* ================= PRIVADAS ================= */}
        <Route
          path="/"
          element={
            <AuthGate>
              <SessionGuardian />
              <RbacProvider>
<LoaderGate>
                <MenuLayout />
              </LoaderGate>
</RbacProvider>
            </AuthGate>
          }
        >
          {/* HOME */}
          <Route index element={<Home />} />

         

          {/* INVENTARIO */}
          
          <Route path="acuses-control" element={<AcusesControlView />} />
          <Route path="inventario" element={<RequireModule module="inventario.ver"><InventarioView /></RequireModule>} />
          <Route path="agregar" element={<RequireModule module="equipos.crear"><InventarioForm /></RequireModule>} />

          {/* PROYECTOS */}
          <Route path="proyectos" element={<RequireModule module="proyectos.ver"><ProyectosDashboardView /></RequireModule>} />
          <Route path="proyectos/command" element={<RequireModule module="proyectos.ver"><ProyectosCommandCenterView /></RequireModule>} />
          <Route path="cotizaciones" element={<RequireModule module="cotizaciones.ver"><CotizacionesV2 /></RequireModule>} />
          <Route path="agregar" element={<RequireModule module="equipos.crear"><InventarioForm /></RequireModule>} />

          {/* CONTRATOS */}
          <Route path="contratos" element={<RequireModule module="services.view"><ContratosView /></RequireModule>} />
          <Route path="contratos/agregar" element={<RequireModule module="services.create"><ContratoForm /></RequireModule>} />
          <Route path="contratos/editar/:id" element={<RequireModule module="services.edit"><ContratoForm /></RequireModule>} />

                    {/* EMPLEADOS */}
          <Route path="empleados" element={<RequireModule module="empleados.ver"><EmpleadosView /></RequireModule>} />
          <Route path="empleados/nuevo" element={<RequireModule module="empleados.crear"><EmpleadoForm /></RequireModule>} />
          <Route path="empleados/editar/:id" element={<RequireModule module="empleados.editar"><EmpleadoForm /></RequireModule>} />
          {/* SITIOS */}
          <Route path="sitios" element={<RequireModule module="sitios.ver"><CredencialesView /></RequireModule>} />
          <Route path="sitios/nuevo" element={<RequireModule module="sitios.crear"><CredencialForm /></RequireModule>} />
          <Route path="sitios/editar/:id" element={<RequireModule module="sitios.editar"><CredencialForm /></RequireModule>} />

          {/* DEV TEST */}
          <Route path="dev/credenciales-test" element={<RequireModule module="configuracion.accesos"><CredencialesTest /></RequireModule>} />

          {/* DOCUMENTOS */}
          <Route path="documentos/carga" element={<RequireModule module="documentos.carga"><UploadDocumentos /></RequireModule>} />
          <Route path="documentos/buscar" element={<RequireModule module="documentos.buscar"><BuscarDocumentos /></RequireModule>} />
          <Route path="documentos" element={<RequireModule module="documentos.carga"><UploadDocumentos /></RequireModule>} />

           {/* DOCUMENTOS BUSQUEDA CONVENCIONAL*/}
          <Route path="documentos/archivo" element={<RequireModule module="documentos.archivo"><ArchivoDocumentosView /></RequireModule>} />

          {/* INCIDENCIAS */}
          <Route path="incidencias" element={<RequireModule module="incidencias.ver"><IncidenciasListado /></RequireModule>} />
          <Route path="incidencias/crear" element={<RequireModule module="incidencias.crear"><IncidenciasCrear /></RequireModule>} />
          <Route path="incidencias/:id" element={<RequireModule module="incidencias.ver"><IncidenciaDetalle /></RequireModule>} />
          <Route path="evidencias" element={<RequireModule module="evidencias.ver"><EvidenciasListado /></RequireModule>} />

          {/* REEMPLAZOS */}
          <Route path="reemplazos" element={<RequireModule module="inventario.ver"><ReemplazosView /></RequireModule>} />

          {/* REPORTES */}
          <Route path="reportes/comparativo" element={<RequireModule module="reportes.comparativo"><ReportesComparativo /></RequireModule>} />
          <Route path="reportes/variacion" element={<RequireModule module="reportes.variacion"><VariacionEjecutiva /></RequireModule>} />
          <Route
            path="reportes/municipios"
            element={<RequireModule module="reportes.municipios"><VariacionMunicipiosMensual /></RequireModule>}
          />

          {/* CONFIG */}
          <Route path="configuracion/accesos" element={<RequireModule module="configuracion.accesos"><AccessAdminView /></RequireModule>} />
          <Route path="configuracion" element={<RequireModule module="configuracion.ver"><Configuracion /></RequireModule>} />

          {/* INSUMOS DE PRODUCCIÃƒÆ’â€œN */}
          <Route
            path="insumos-produccion"
            element={
              <RequireModule module="insumos.manage">
                <InsumosProduccionView />
              </RequireModule>
            }
          />

          {/* CONTROL DE FOLIOS */}
          <Route
            path="folios"
            element={<FoliosCommandCenterView />}
          />
          {/* REMISIONES DE ENVIO */}
          <Route
            path="remisiones-envio"
            element={<RemisionesEnvioView />}
          />

          {/* FALLBACK PRIVADO */}
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}